import styled from "styled-components";

import Toggle from "src/organization/pages/project/environment/metrics/components/Toggle";

export const ControlFilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  .deployments-toggle {
    margin: 0;
  }
`;

export const Deployments = styled(Toggle)``;
